import React, { useState } from 'react';
import DefaultLayout from '../../../layouts/default';
import GuidanceWidgets from './components/GuidanceWidgets';
import OpeningCheckForm from './components/OpeningCheckForm';
import OpeningCheckHeader from './components/OpeningCheckHeader';
import CheckProgressWidget from './components/CheckProgressWidget';
import ComplianceRecordsSummary from './components/ComplianceRecordsSummary';
import PatFormChecklist from './components/PatFormChecklist';
import PatSummaryDashboardRow from './components/PatSummaryDashboardRow';
import { getLocalTodayString } from '../../../components/CreationDate';
import { useParams, useSearchParams } from "react-router-dom";

function DynamicCheckPage() {
  const { slug } = useParams();
  const [searchParams] = useSearchParams();
  const dateFromParams = searchParams.get("date");
  const [selectedDate, setSelectedDate] = useState(
    dateFromParams || getLocalTodayString()
  );

  // Any slug containing one of these values will use the PAT layout
  const patCheckSlugs = [
    'pat-check',
    'staff-training-check'
  ];

  const isPatCheck = patCheckSlugs.some(pattern =>
    slug?.includes(pattern)
  );


  return (
    <DefaultLayout>
      <OpeningCheckHeader
        slug={slug}
        selectedDate={selectedDate}
        setSelectedDate={setSelectedDate}
      />

      {isPatCheck ? (
            <>
              <PatSummaryDashboardRow />
              <PatFormChecklist slug={slug} selectedDate={selectedDate} />
            </>
      ) : (
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-4">
          <div className="col-span-12 lg:col-span-9">
              <OpeningCheckForm
                slug={slug}
                selectedDate={selectedDate} />
          </div>
            <div className="col-span-12 lg:col-span-3">
              <CheckProgressWidget slug={slug} selectedDate={selectedDate} />
              <ComplianceRecordsSummary  />
              <GuidanceWidgets />
            </div>
        </div>
      )}

    </DefaultLayout>
  );
}

export default DynamicCheckPage;